import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import "../main-studio.css";

const navItems = [
  { label: "Products", path: "/products" },
  { label: "Ecosystem", path: "/#ecosystem", hash: "ecosystem" },
  { label: "Method", path: "/#philosophy", hash: "philosophy" },
  { label: "Labs", path: "https://labs.willovate.in", external: true },
  { label: "Company", path: "/about" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  const goTo = (hash) => {
    setOpen(false);
    if (location.pathname === "/") {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    navigate(`/#${hash}`);
  };

  const onNav = (event, item) => {
    if (!item.hash) return;
    event.preventDefault();
    goTo(item.hash);
  };

  return (
    <>
      <header className="wv-header">
        <Link to="/" className="wv-brand" aria-label="Willovate home">
          <img src="/willovate-mark.png" alt="" />
          <span><strong>WILLOVATE</strong><small>RUNTIME 01 · NAGPUR, INDIA</small></span>
        </Link>

        <nav className="wv-nav" aria-label="Main navigation">
          {navItems.map((item, index) => (
            item.hash ? (
              <a key={item.label} href={item.path} onClick={(event) => onNav(event, item)}>
                <span>{item.label}</span><small>{String(index + 1).padStart(2, "0")}</small>
              </a>
            ) : item.external ? (
              <a key={item.label} href={item.path} target="_blank" rel="noopener noreferrer">
                <span>{item.label}</span><small>{String(index + 1).padStart(2, "0")}</small>
              </a>
            ) : (
              <NavLink key={item.label} to={item.path}>
                <span>{item.label}</span><small>{String(index + 1).padStart(2, "0")}</small>
              </NavLink>
            )
          ))}
        </nav>

        <button type="button" className="wv-header-cta" onClick={() => goTo("contact")}>
          Start a conversation <ArrowUpRight size={18} />
        </button>
        <button type="button" className="wv-menu-trigger" onClick={() => setOpen(true)} aria-label="Open menu">
          <Menu size={23} />
        </button>
      </header>

      {open ? (
        <aside className="wv-mobile-menu" role="dialog" aria-modal="true" aria-label="Main menu">
          <div className="wv-mobile-head">
            <Link to="/" className="wv-mobile-brand"><img src="/willovate-mark.png" alt="" /><span>WILLOVATE</span></Link>
            <button type="button" onClick={() => setOpen(false)} aria-label="Close menu"><X size={24} /></button>
          </div>
          <nav>
            {navItems.map((item, index) => (
              item.external ? (
                <a key={item.label} href={item.path} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>
                  <span>{item.label}</span><small>{String(index + 1).padStart(2, "0")}</small>
                </a>
              ) : (
                <Link key={item.label} to={item.path} onClick={(event) => onNav(event, item)}>
                  <span>{item.label}</span><small>{String(index + 1).padStart(2, "0")}</small>
                </Link>
              )
            ))}
          </nav>
          <button type="button" className="wv-mobile-cta" onClick={() => goTo("contact")}>
            Start a conversation <ArrowUpRight size={19} />
          </button>
          <p>Connected software. Real business impact.</p>
        </aside>
      ) : null}
    </>
  );
};

export default Header;
